/* eslint-disable no-undef */
const config = {
  AWS_REGION: __AWS_REGION__,
  AWS_COGNITO_IDENTITY_POOL_ID: __COGNITO_IDENTITY_POOL_ID__, // leave blank if not set
  AWS_COGNITO_USER_POOL_ID: __COGNITO_USER_POOL_ID__,
  AWS_COGNITO_CLIENT_ID: __COGNITO_CLIENT_ID__,
  AWS_COGNITO_CLIENT_DOMAIN: __COGNITO_CLIENT_DOMAIN__,
  COGNITO_SCOPE: __COGNITO_SCOPE__,
  CLOUDFRONT_DISTRIBUTION_DOMAIN: __CLOUDFRONT_DISTRIBUTION_DOMAIN__,
  production: __NODE_ENV__ == "production" ? true : false,
  environment_name: __TF_VAR_environment__,
  application_name: __APP_NAME__,
  application_version: __APP_VERSION__,
  APP_DOMAIN_ENDPOINT: __APP_DOMAIN_ENDPOINT__,
  API_ENDPOINT: __API_ENDPOINT__,
  LAMBDA_URL: __LAMBDA_BASE_URL__,
  SENTRY_DSN: __SENTRY_DSN__,
  MATOMO_SITE_ID: __MATOMO_SITE_ID__,
};

export default config;
